module.exports = __webpack_public_path__ + "media/images/japan/tokyo_guide/sightseeing_4-4038ebd98b9a20766c60c3c061de6c81.jpg";